import React from "react";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import PropTypes from "prop-types";
import "../css/home.css";

const styles = {
  parent: {
    fontSize: "0.1px",
    color: "white",
  },
  link: {
    textDecoration: "line-trough",
  },
  span: {
    color: "gray",
  },
};

const TradingViewChart = (props) => {
  return (
    <div
      style={{
        border: "1px solid rgba(16, 33, 56, 0.08)",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
        width: "100%",
        background: "#ffffff",
      }}
    >
      <AdvancedRealTimeChart
        range="1D"
        height={window.innerWidth <= 768 ? 300 : 350} // Mobile height adjustment
        width="100%" // Responsive width
        symbol={props.symbol}
        hide_legend={false}
        hide_side_toolbar={true}
        hide_top_toolbar={true}
        hide_ideas={true}
        allow_symbol_change={false}
        disabled_features={["use_localstorage_for_settings"]}
        trendLineColor="rgba(101, 101, 101, 1)"
        copyrightStyles={styles}
        largeChartUrl=""
        timezone="exchange"
      />
    </div>
  );
};

TradingViewChart.propTypes = {
  symbol: PropTypes.string.isRequired,
};

export default TradingViewChart;
